import i18n, { use as registerPlugin, init as initI18n } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      equipmentActionPortalTitle: 'Equipment Action Portal',
      site: 'Site',
      department: 'Department',
      scanQRCode: 'SCAN QR CODE',
      equipmentNumber: 'Equipment Number',
      description: 'Description',
      employeeNumber: 'Employee Number',
      selectServiceArea: 'Select Service Area',
      selectServiceAction: 'Select Service Action',
      comment: 'Comment',
      cancel: 'CANCEL',
      continue: 'CONTINUE',
      submit: 'SUBMIT',
      notSelected: 'Not Selected',
      successTitle: 'Success!',
      scannedValue: 'Scanned value',
      okButton: 'OK',
      maintenance: 'Maintenance',
      quality: 'Quality',
      departmentManager: 'Department Manager',
      machineDown: 'Machine Down',
      lineDown: 'Line Down',
      plannedRepair: 'Planned Repair (<5 hrs)',
      default: 'Default',
      describeProblem: 'Describe Problem',
      describeProblemInstructions:
        'Responding to the questions below is <b>required</b>. They help us to generate better diagnosis and troubleshooting suggestions.',
      yesButton: 'Yes',
      noButton: 'No',
      dontKnowButton: "I Don't Know",
      submitWorkOrder: 'Submit Work Order',
      closeRequest: 'Close Request',
      additionalDetails: 'Additional Details',
      refetchQuestions: 'Refetch Questions',
      selectClosureReasonTitle: 'Select Closure Reason',
      selectClosureReasonParagraph: 'Please select a reason for closing this request.',
      reasonLabel: 'Reason',
      reasonFixedProblem: 'I fixed the problem',
      reasonTrainingTesting: 'I was training/testing',
      reasonOther: 'Other',
      location: 'Location',
      costCenter: 'Cost Center',
      errorTitle: 'Error!',
      warningTitle: 'Warning!',
      followUpQuestionsErrorContent:
        'An error occurred fetching follow-up questions. You can still submit a work order by clicking "Submit Work Order" or you can try fetching questions again by clicking "Refetch Questions". Error details: {{error}}',
      aiSummaryErrorContent:
        'An error occurred creating the AI-generated work order summary. Click OK to submit the work order without the AI-generated summary. Error details: "{{error}}"',
      closeRequestErrorContent: 'An error occurred closing the request: {{error}}',
      conversationErrorContent:
        'An error occurred generating follow-up questions. You can still submit your work order directly, or cancel to try again. Error details: {{error}}',
      equipmentNotFoundContent: 'Equipment Not Found!',
      downtimeEventStartedContent: '{{serviceArea}} {{serviceAction}} Event was started!',
      downtimeStartErrorContent: 'An error occurred starting Downtime Event! {{error}}',
      equipmentMustBeSelectedContent: 'Equipment Must be Selected!',
      downtimeEventMustBeSelectedContent: 'Downtime Event must be selected!',
      qualityEventSentContent: 'Quality Downtime Event was sent!',
      deptManagerSelectedContent: 'Dept Manager Selected!',
      infoTitle: 'Info!',
      // Menu bar translations
      selectLanguage: 'Select Language',
      provideFeedback: 'Provide Feedback',
      requestAccess: 'Request Access',
      thriveStatus: 'Thrive Status',
      myProfile: 'My Profile',
      // Language modal translations
      selectDesiredLanguage: 'Select Desired Language',
      closeButton: 'Close',
      savePreferences: 'Save Preferences',
      languageEnglish: 'ENGLISH',
      languageSpanish: 'SPANISH',
      loading: 'Loading',
      saving: 'Saving',
      addAdditionalDetails: 'Add Additional Details',
    },
  },
  es: {
    translation: {
      equipmentActionPortalTitle: 'Portal de Acciones de Equipos',
      site: 'Sitio',
      department: 'Departamento',
      scanQRCode: 'ESCANEAR CÓDIGO QR',
      equipmentNumber: 'Número de equipo',
      description: 'Descripción',
      employeeNumber: 'Número de empleado',
      selectServiceArea: 'Seleccione área de servicio',
      selectServiceAction: 'Seleccione acción de servicio',
      comment: 'Comentario',
      cancel: 'CANCELAR',
      continue: 'CONTINUAR',
      submit: 'ENVIAR',
      notSelected: 'No Seleccionado',
      successTitle: '¡Éxito!',
      scannedValue: 'Valor escaneado',
      okButton: 'ACEPTAR',
      maintenance: 'Mantenimiento',
      quality: 'Calidad',
      departmentManager: 'Gerente de Departamento',
      machineDown: 'Máquina Parada',
      lineDown: 'Línea Parada',
      plannedRepair: 'Reparación Planificada (<5 h)',
      default: 'Por defecto',
      describeProblem: 'Describa el problema',
      describeProblemInstructions:
        'Responder a las preguntas a continuación es <b>obligatorio</b>. Nos ayudan a generar mejores diagnósticos y sugerencias para la resolución de problemas.',
      yesButton: 'Sí',
      noButton: 'No',
      dontKnowButton: 'No lo sé',
      submitWorkOrder: 'Enviar Orden de Trabajo',
      closeRequest: 'Cerrar Solicitud',
      additionalDetails: 'Detalles adicionales',
      refetchQuestions: 'Recargar preguntas',
      selectClosureReasonTitle: 'Seleccionar motivo de cierre',
      selectClosureReasonParagraph: 'Seleccione un motivo para cerrar esta solicitud.',
      reasonLabel: 'Motivo',
      reasonFixedProblem: 'He solucionado el problema',
      reasonTrainingTesting: 'Estaba en entrenamiento/pruebas',
      reasonOther: 'Otro',
      location: 'Ubicación',
      costCenter: 'Centro de Costos',
      errorTitle: '¡Error!',
      warningTitle: '¡Advertencia!',
      followUpQuestionsErrorContent:
        'Ocurrió un error al obtener las preguntas de seguimiento. Aún puede enviar la orden de trabajo haciendo clic en "Enviar Orden de Trabajo" o puede intentar recargar las preguntas haciendo clic en "Recargar preguntas". Detalles del error: {{error}}',
      aiSummaryErrorContent:
        'Ocurrió un error al crear el resumen de la orden de trabajo generado por IA. Haga clic en Aceptar para enviar la orden de trabajo sin el resumen generado por IA. Detalles del error: "{{error}}"',
      closeRequestErrorContent: 'Ocurrió un error al cerrar la solicitud: {{error}}',
      conversationErrorContent:
        'Ocurrió un error al generar las preguntas de seguimiento. Aún puede enviar la orden de trabajo directamente, o cancelar para intentarlo de nuevo. Detalles del error: {{error}}',
      equipmentNotFoundContent: '¡Equipo no encontrado!',
      downtimeEventStartedContent: '¡El evento de {{serviceArea}} {{serviceAction}} ha sido iniciado!',
      downtimeStartErrorContent: 'Ocurrió un error al iniciar el evento de inactividad! {{error}}',
      equipmentMustBeSelectedContent: '¡El equipo debe seleccionarse!',
      downtimeEventMustBeSelectedContent: '¡El evento de inactividad debe seleccionarse!',
      qualityEventSentContent: '¡El evento de inactividad de Calidad fue enviado!',
      deptManagerSelectedContent: '¡Gerente de Departamento seleccionado!',
      infoTitle: '¡Información!',
      // Menu bar translations
      selectLanguage: 'Seleccionar Idioma',
      provideFeedback: 'Proporcionar Comentarios',
      requestAccess: 'Solicitar Acceso',
      thriveStatus: 'Estado Thrive',
      myProfile: 'Mi Perfil',
      // Language modal translations
      selectDesiredLanguage: 'Seleccionar Idioma Deseado',
      closeButton: 'Cerrar',
      savePreferences: 'Guardar Preferencias',
      languageEnglish: 'INGLÉS',
      languageSpanish: 'ESPAÑOL',
      loading: 'Cargando',
      saving: 'Guardando',
      addAdditionalDetails: 'Añadir Detalles Adicionales',
    },
  },
};

registerPlugin(LanguageDetector);
registerPlugin(initReactI18next);

initI18n({
  resources,
  fallbackLng: 'en',
  debug: false,
  interpolation: {
    escapeValue: false, // React already does escaping
  },
  detection: {
    order: ['sessionStorage', 'navigator'],
    lookupSessionStorage: 'i18nextLng',
    caches: ['sessionStorage'],
  },
});

// eslint-disable-next-line unicorn/prefer-export-from
export default i18n;
